import { createSlice } from '@reduxjs/toolkit'
import { isServer } from '@root/library/isServer';
import { getDefaultPath } from '@root/library/url_sync';

function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}

const preKeys = getDefaultPath();
const initialState = {
  collapsed: true,
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
}

const slice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    toggleCollapsed: (state) => {
      state.collapsed = !state.collapsed
    },
    toggleAll: (state, { payload }) => {
      state.view = getView(payload.width);
      state.collapsed = getView(payload.width) !== 'DesktopView';
      state.height = payload.height
    },
    changeOpenKeys: (state, { payload }) => {
      state.openKeys = payload
    },
    changeCurrent: (state, { payload }) => {
      state.current = payload
    },
    clearMenu: () => initialState,
  },
});

// Actions
export const { toggleCollapsed, toggleAll, changeOpenKeys, changeCurrent, clearMenu } = slice.actions;

export default slice.reducer;